import $ from 'jquery'

$(document).ready(init)

function init() {
  const heroVideoWrapper = $('.hero-video__file')
  
  if (!heroVideoWrapper.length) return

  const videos = heroVideoWrapper.find('video')
  const playBtn = heroVideoWrapper.find('.hero-video__play')
  const pauseBtn = heroVideoWrapper.find('.hero-video__pause')

  // Pause button click handler
  pauseBtn.click(function() {
    videos.each(function() {
      this.pause()
    })
    pauseBtn.hide()
    playBtn.show()
  })

  // Play button click handler
  playBtn.click(function() {
    videos.each(function() {
      this.play()
      // Unmute video on play
      this.muted = false
    })
    playBtn.hide()
    pauseBtn.show()
  })
}
